<template>
  <div>
    <div v-if="todayAbsence.length">
      <div>
        <div v-if="loading">
          <v-progress-linear
            class="mx-2"
            color="primary"
            indeterminate
          ></v-progress-linear>
        </div>
        <div v-if="attendance">
          <div class="mb-2">
            <v-breadcrumbs class="px-0" :items="breadcrumbsItems"></v-breadcrumbs>
          </div>
          <div class="mb-6">
            <h2>
              {{ $t('attendance.absenceConfirmDelete') }}<br /><br />{{ attendance.child.lastName
              }}{{ attendance.child.firstName }}
            </h2>
               <br /><br />
              {{ $t('common.date') }} : {{ formatDate(attendance.date) }}
          </div>
          <div class="mb-4">
            <div>{{ $t('attendance.reason') }}</div>
            <template v-if="todayAbsence[0] && todayAbsence[0].absenceDetails">
              <v-card-text style="white-space:pre-wrap;">
                {{ showReason(todayAbsence[0].absenceDetails.reason) }}
              </v-card-text>
              <template v-if="todayAbsence[0].absenceDetails.comment">
                <v-card-subtitle> {{ $t('attendance.comment') }} </v-card-subtitle>
                <v-card-text style="white-space:pre-wrap;">
                  {{ todayAbsence[0].absenceDetails.comment }}
                </v-card-text>
              </template>
            </template>
          </div>
          <v-row justify="center" class="pt-10">
            <v-btn
              @click="deleteAbsence"
              :disabled="isSaving"
              color="error"
              variant="outlined"
              x-large
              >{{ $t('common.delete') }}</v-btn
            >
          </v-row>
          <div>
            <v-progress-linear
              v-if="isSaving"
              indeterminate
              color="primary"
              class="my-8"
            ></v-progress-linear>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        <!-- お休み登録 -->
        <v-dialog max-width="640px" v-model="isAbsenceRegisterDialogOpen">
          <v-card>
            <v-toolbar dark color="primary" tile flat class="mb-5">
              <v-toolbar-title>{{ $t('attendance.absenceRegistration', { name: attendance.child.lastName + ' ' + attendance.child.firstName }) }}</v-toolbar-title>
            </v-toolbar>
            <div>
              <h2>
                <center>
                  {{ formatDate(attendance.date) }}
                </center>
              </h2>
            </div>
            <v-card-text class="py-3">
              <v-select
                v-model="reason"
                :rules="[rules.required]"
                :label="$t('attendance.reason')"
                :items="choices"
                item-title="text"
                item-value="value"
                variant="outlined"
                density="compact"
                color="primary"
              />
              <v-select
                v-model="infectionReason"
                :rules="[infectionRules]"
                v-if="reason === 'infection'"
                :label="$t('attendance.detail')"
                :items="infectionChoices"
                item-title="text"
                item-value="value"
                variant="outlined"
                density="compact"
                color="primary"
              />
              <v-textarea
                v-model="comment"
                v-if="reason === 'others'"
                :rules="[rules.counter500]"
                :label="$t('attendance.comment')"
                auto-grow
                variant="outlined"
                density="compact"
                color="primary"
              />
            </v-card-text>

            <v-card-actions class="justify-center">
              <v-btn
                :disabled="isSaving"
                variant="flat"
                color="primary"
                class="mx-2"
                @click="clickAbsencePost"
              >
                {{ $t('common.save') }}
              </v-btn>
            </v-card-actions>
            <v-progress-linear
              v-if="isUpdatingStaffs"
              indeterminate
              color="primary"
            ></v-progress-linear>
          </v-card>
        </v-dialog>
        <div v-if="loading">
          <v-progress-linear
            class="mx-2"
            color="primary"
            indeterminate
          ></v-progress-linear>
        </div>
        <div v-if="attendance">
          <div class="mb-2">
            <v-breadcrumbs class="px-0" :items="breadcrumbsItems"></v-breadcrumbs>
          </div>
          <div class="mb-6">
            <h2>
              {{ formatDate(attendance.date) }} : {{ attendance.child.lastName
              }}{{ attendance.child.firstName }}
            </h2>
          </div>
          <div class="mb-4">
            <div>{{ $t('attendance.checkInTime') }}</div>
            <v-text-field variant="outlined" type="time" v-model="attendedAt" color="primary"></v-text-field>
          </div>
          <div class="mb-4">
            <div>{{ $t('attendance.checkOutTime') }}</div>
            <v-text-field variant="outlined" type="time" v-model="leftAt" color="primary"></v-text-field>
          </div>
          <v-row justify="center">
            <v-btn
              color="primary"
              variant="flat"
              x-large
              :disabled="isSaving"
              @click="save"
              >{{ $t('common.save') }}</v-btn
            >
          </v-row>
          <v-row justify="center" class="pt-10">
            <v-btn
              @click="deleteAttendance"
              :disabled="isSaving || attendance.attendanceId == -1"
              color="error"
              variant="outlined"
              x-large
              >{{ $t('attendance.deleteCheckInOut') }}</v-btn
            >
          </v-row>
          <v-row justify="center" class="pt-10">
            <v-btn
              @click="openModalAbsence"
              :disabled="isSaving || attendedAt !== null"
              color="primary"
              variant="outlined"
              x-large
              >{{ $t('attendance.registerAbsence') }}</v-btn
            >
          </v-row>
          <div>
            <v-progress-linear
              v-if="isSaving"
              indeterminate
              color="primary"
              class="my-8"
            ></v-progress-linear>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { attendanceEditModule } from "@/store/dataModules/attendanceEditModule";
import dayjs from "dayjs";
import ApiAttendance from "@/api/ApiAttendance";
import LocalDataService from "@/service/LocalDataService";
import { chatModule } from '@/store/dataModules/chatModule';
import { AbsenceReason, AbsenceReasonType, NurseryAttendanceResponse } from 'chaild-api/lib';

interface DataType {
  isAbsenceRegisterDialogOpen: boolean;
  isSaving: boolean;
  loading: boolean;
  reason: string;
  infectionReason: string;
  comment: string | null;
  rules: {
    required: (value: any) => boolean | string;
    counter500: (value: any) => boolean | string;
  };
  infectionRules: (value: any) => boolean | string;
  choices: { text: string; value: string }[];
  infectionChoices: { text: string; value: string }[];
  isUpdatingStaffs: boolean;
}

export default defineComponent({
  computed: {
    attendance() {
      return attendanceEditModule.attendance;
    },
    todayAbsence() {
      const attendanceDate = attendanceEditModule.attendance ? attendanceEditModule.attendance.date : null;
      if (!attendanceDate) {
        return [];
      }
      return chatModule.chatsAbsence.filter(ca => ca.date == attendanceDate);
    },
    attendedAt: {
      get(): string | null {
        if (
          attendanceEditModule.attendance &&
          attendanceEditModule.attendance.attendedAt
        ) {
          return dayjs(attendanceEditModule.attendance.attendedAt).format(
            "HH:mm"
          );
        }
        return null;
      },
      set(value: string) {
        if (this.date && value) {
          const date = dayjs(this.date + value).toISOString();
          attendanceEditModule.setAttendedAtValue(date);
        }
      },
    },
    leftAt: {
      get(): string | null {
        if (
          attendanceEditModule.attendance &&
          attendanceEditModule.attendance.leftAt
        ) {
          return dayjs(attendanceEditModule.attendance.leftAt).format("HH:mm");
        }
        return null;
      },
      set(value: string) {
        if (this.date && value) {
          const date = dayjs(this.date + value).toISOString();
          attendanceEditModule.setLeftAtValue(date);
        }
      },
    },
    date() {
      return this.$route.params.date;
    },
    breadcrumbsItems: function () {
      //日付をlocalStorageに保存
      const routeDate = this.$route.params.date;
      localStorage.setItem('date', routeDate as string);
      return [
        { title: this.$t('attendance.title'), href: "/attendance/list", color: "primary" },
        { title: this.$t('attendance.editCheckInOut'), href: "", disabled: true },
      ];
    },
  },

  data: (): DataType => {
    return {
      reason: '',
      infectionReason: '',
      comment: '',
      isAbsenceRegisterDialogOpen: false,
      isSaving: false,
      loading: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
        counter500: (value) => (value || '').length <= 500 || 'Please enter within 500 characters.',
      },
      infectionRules: (value) => !!value || 'This field is required.',
      choices: [] as { text: string; value: string }[],
      infectionChoices: [] as { text: string; value: string }[],
      isUpdatingStaffs: false,
    };
  },

  methods: {
    formatDate(value: string) {
      return value ? dayjs(value).format('DD-MM-YYYY') : '';
    },
    async clickAbsencePost() {
      this.isSaving = true;
      const startedAt = this.attendance?.date;
      const endedAt = this.attendance?.date;
      if (!this.comment) {
        this.comment = null;
      }
      if (!startedAt || !endedAt) {
        return false;
      }
      try {
        if (this.reason === 'infection') {
          if (!this.infectionReason) {
            alert(this.$t('attendance.selectDetail'));
            this.isSaving = false;
            return false;
          }
          await chatModule.postChatsAbsence({
            childId: Number(this.$route.params.childId),
            startedAt: startedAt,
            endedAt: endedAt,
            reason: this.infectionReason,
          });
        } else {
          if (!this.reason) {
            alert(this.$t('attendance.selectReason'));
            this.isSaving = false;
            return false;
          }
          if (this.reason === 'others') {
            if (!this.comment) {
              alert(this.$t('attendance.enterComment'));
              this.isSaving = false;
              return false;
            }
            if (this.comment?.length >= 500) {
              alert(this.$t('attendance.commentMaxLength'));
              this.isSaving = false;
              return false;
            }
          }
          await chatModule.postChatsAbsence({
            childId: Number(this.$route.params.childId),
            startedAt: startedAt,
            endedAt: endedAt,
            reason: this.reason,
            comment: this.comment,
          });
        }
        this.$emit('posted');
        this.$emit('close');
        this.isSaving = false;
        this.$router.push({ path: "/attendance/list" });
      } catch (error) {
        this.$emit('close');
        this.isSaving = false;
        this.$router.push({ path: "/attendance/list" });
      }
    },
    showReason(reason: AbsenceReasonType): string {
      switch (reason) {
        case AbsenceReason.fever:
          return this.$t('attendance.absenceReasons.fever');
        case AbsenceReason.personal:
          return this.$t('attendance.absenceReasons.personal');
        case AbsenceReason.infStrep:
          return this.$t('attendance.infectionTypes.infStrep');
        case AbsenceReason.infMycoplasma:
          return this.$t('attendance.infectionTypes.infMycoplasma');
        case AbsenceReason.infHFMD:
          return this.$t('attendance.infectionTypes.infHFMD');
        case AbsenceReason.infSlappedCheek:
          return this.$t('attendance.infectionTypes.infSlappedCheek');
        case AbsenceReason.infStomach:
          return this.$t('attendance.infectionTypes.infStomach');
        case AbsenceReason.infHerpangina:
          return this.$t('attendance.infectionTypes.infHerpangina');
        case AbsenceReason.infRS:
          return this.$t('attendance.infectionTypes.infRS');
        case AbsenceReason.infZoster:
          return this.$t('attendance.infectionTypes.infZoster');
        case AbsenceReason.infRoseola:
          return this.$t('attendance.infectionTypes.infRoseola');
        case AbsenceReason.infImpetigo:
          return this.$t('attendance.infectionTypes.infImpetigo');
        case AbsenceReason.covid19:
          return this.$t('attendance.infectionTypes.covid19');
        case AbsenceReason.others:
          return this.$t('attendance.absenceReasons.others');
        default:
          return '';
      }
    },
    async getAttendance() {
      this.loading = true;
      await attendanceEditModule.getAttendance();
      this.loading = false;
    },
    async save() {
      this.isSaving = true;
      if (attendanceEditModule.attendance) {
        if (attendanceEditModule.attendance.attendanceId == -1) {
          // create
          await attendanceEditModule.createAttendance();
        } else {
          // update
          await attendanceEditModule.updateAttendance().catch(() => {
            alert(this.$t('attendance.saveFailed'));
          });
        }
      }
      this.isSaving = false;
    },
    async deleteAbsence() {
      this.isSaving = true;
      const answer = confirm(this.$t('attendance.deleteAbsenceConfirm'));
      this.isSaving = true;
      if (answer) {
        const nurseryId = LocalDataService.getNurseryId();
        if (this.attendance) {
          await chatModule.deleteChatsAbsence({
            childId: Number(this.$route.params.childId),
            date: this.attendance.date,
          });
          this.$emit('posted');
          alert(this.$t('attendance.deleted'));
        } else {
          console.error('Attendance object is null.');
        }
        this.$emit('posted');
        this.$router.push({ path: "/attendance/list" });
      }
      this.isSaving = false;
    },
    async deleteAttendance() {
      const answer = confirm(this.$t('attendance.deleteCheckInOutConfirm'));
      this.isSaving = true;
      if (answer) {
        const nurseryId = LocalDataService.getNurseryId();
        if (
          this.attendance?.attendanceId &&
          this.attendance.child.childId &&
          nurseryId
        ) {
          const response = await ApiAttendance.deleteAttendance({
            attendanceId: this.attendance.attendanceId,
            childId: this.attendance.child.childId,
            nurseryId,
          }).catch((e) => console.warn(e));
          if (response) {
            alert(this.$t('attendance.deleted'));
            this.$router.push({ path: "/attendance/list" });
          }
        }
      }
      this.isSaving = false;
    },
    async openModalAbsence() {
      this.isAbsenceRegisterDialogOpen = true;
    },
  },

  async mounted() {
    this.choices = [
      { text: this.$t('attendance.absenceReasons.personal'), value: 'personal' },
      { text: this.$t('attendance.absenceReasons.fever'), value: 'fever' },
      { text: this.$t('attendance.absenceReasons.infection'), value: 'infection' },
      { text: this.$t('attendance.absenceReasons.others'), value: 'others' },
    ];
    this.infectionChoices = [
      { text: this.$t('attendance.infectionTypes.infStrep'), value: 'infStrep' },
      { text: this.$t('attendance.infectionTypes.infMycoplasma'), value: 'infMycoplasma' },
      { text: this.$t('attendance.infectionTypes.infHFMD'), value: 'infHFMD' },
      { text: this.$t('attendance.infectionTypes.infSlappedCheek'), value: 'infSlappedCheek' },
      { text: this.$t('attendance.infectionTypes.infStomach'), value: 'infStomach' },
      { text: this.$t('attendance.infectionTypes.infHerpangina'), value: 'infHerpangina' },
      { text: this.$t('attendance.infectionTypes.infRS'), value: 'infRS' },
      { text: this.$t('attendance.infectionTypes.infZoster'), value: 'infZoster' },
      { text: this.$t('attendance.infectionTypes.infRoseola'), value: 'infRoseola' },
      { text: this.$t('attendance.infectionTypes.infImpetigo'), value: 'infImpetigo' },
      { text: 'COVID-19', value: 'covid19' },
    ];
    this.loading = true;
    const date = this.$route.params.date;
    const childId = this.$route.params.childId;
    await chatModule.getChatsAbsence(Number(childId));

    if (date && childId) {
      try {
        const parsed = parseInt(childId as string, 10);
        attendanceEditModule.setChildId(parsed);
        attendanceEditModule.setDate(date as string);

        this.getAttendance();
      } catch {
        return;
      }
    }
  },
});
</script>
